import { BREAKING } from "@/data/articles";

export function Ticker() {
  // Items are rendered twice so the CSS loop can scroll seamlessly.
  const items = [...BREAKING, ...BREAKING];
  return (
    <div className="flex items-stretch overflow-hidden border-b border-rule bg-white">
      <span className="z-10 flex shrink-0 items-center bg-brand px-3 text-[12px] font-extrabold uppercase tracking-wider text-white">
        Breaking
      </span>
      <div className="relative flex-1 overflow-hidden py-2">
        <div className="ticker-track flex w-max gap-10 whitespace-nowrap pl-4 text-[14px] font-bold">
          {items.map((t, i) => (
            <span key={i} className="flex items-center gap-10">
              {t}
              <span className="text-brand" aria-hidden>■</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
